import { render, staticRenderFns } from "./GettingStartedList.vue?vue&type=template&id=1b3d25ac&scoped=true"
import script from "./GettingStartedList.vue?vue&type=script&lang=js"
export * from "./GettingStartedList.vue?vue&type=script&lang=js"
import style0 from "./GettingStartedList.vue?vue&type=style&index=0&id=1b3d25ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d25ac",
  null
  
)

export default component.exports